import { useMutation } from "@tanstack/react-query";
import { useApi } from "@/core/api";

interface QuickbooksAuthorizeResponse {
  authorize_url: string;
}

export const useStartQuickbooksOauth = (businessId?: string | null) => {
  const api = useApi();

  return useMutation({
    mutationFn: (): Promise<QuickbooksAuthorizeResponse> => {
      if (!businessId) {
        return Promise.reject(new Error("Business not found."));
      }

      return api
        .post(`/businesses/${businessId}/quickbooks/oauth/authorize`)
        .then((response) => response.data);
    },
  });
};
